import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class FirmwareService {
  readonly baseURL = DDP_ENV.adminFunctionUrl;

  constructor(private _http: Http, private cookieService: CookieService) { }

  getAllFirmWares(page, size, regexPattern) {
    return this._http.get(this.baseURL + '/firmwaredetails?' +
        'page=' + page +
        '&size=' + size +
        '&regexPattern=' + regexPattern, this.buildHeaders());
  }

  addFirmware(firmwareDetails) {
    return this._http.post(this.baseURL + '/firmwaredetails/upload', firmwareDetails, this.buildHeaders());
  }

  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }

}
